export const media = {
    LARGE_DESKTOP: '@media (min-width: 1440px)',
	DESKTOP: '@media (min-width: 1280px)',
	LAPTOP: '@media (min-width: 1024px) and (max-width: 1279px)',
	TABLET: '@media (min-width: 768px) and (max-width: 1023px)',
	MOBILE: '@media (max-width: 767px)',
	SMALL: '@media (max-width: 374px)',

	AT_LEAST_TABLET: '@media (min-width: 768px)',
	AT_LEAST_LAPTOP: '@media (min-width: 1024px)',
	MOBILE_OR_TABLET: '@media (max-width: 1023px)'
};
